<template>
    <div class="service">
        <div  :class="{'banner':true,'blankBanner':!bannerUrl}">
            <img style="width:100%;cursor:pointer" @click="changeLink()" :src="bannerUrl" alt="">
        </div>
        
            <div class="box1">
                <div class="content">
                    <ul>
                        <li>
                            <div class="text">
                                <div class="title">培训服务</div>
                                <div class="detail">提供专业的师资培训，培养实操型人才</div>
                            </div>
                        </li>
                        <li>
                            <div class="text">
                                <div class="title">课程开发</div>
                                <div class="detail">定制开发课程，因材施教</div>
                            </div>
                        </li>
                        <li>
                            <div class="text">
                                <div class="title">技能鉴定</div>
                                <div class="detail">提供机械行业职业资格鉴定服务</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="box2">
                <div class="content">
                    <div class="commonTitle">
                        <div class="top">培训服务</div>
                        <div class="bottom">TRAINING SERVICES</div>
                        <div class="astract">“人才培养、师资先行”，公司针对智能制造与工业机器人方向的专业教师，提供职业技能鉴定考证、企业实践与专业教学培训班。涵盖工业机器人操作编程、工业机器人机电安装调试与维修、工业机器人集成装调与应用、工业机器人离线编程、工业机器人工艺应用、工业机器人仿真实训、智能产线装调、智能产线运营与管理等教学内容，旨在提高师资专业技能与信息化教学水平。</div>
                        <img src="../assets/serviceModal1.png" alt="">
                    </div>
                </div>
            </div>
            <div class="box3">
                <div class="content">
                    <div class="commonTitle">
                        <div class="top">课程开发</div>
                        <div class="bottom">COURSE DEVELOPMENT</div>
                        <div class="astract">全媒体新型数字教材，创新教材编写模式，打破学科体系，融合利用任务驱动教学过程，理论与实践有机结合，重难点微课二维码手机扫码学习，提高学生学习兴趣，减少教师讲授工作量，实现翻转课堂，让学生乐于学习。</div>
                        <div class="other">
                            <div class="left">
                                <div class="smallBox">
                                    <p>信息化课堂构建</p>
                                    <ul>
                                        <li><span>·</span>在线编排富媒体课件，支持信息化课堂个性化重构</li>
                                        <li><span>·</span>海量微课、视频、3D模型等课程素材库管理</li>
                                        <li><span>·</span>支持教师备课授课一体化、学生O2O学习</li>
                                        <li><span>·</span>课程资源与教学过程大数据分析管理</li>
                                    </ul>
                                </div>
                                <div class="smallBox bottomBox">
                                    <p>新形态一体化系列教材</p>
                                    <div>联合相关单位组织策划工业机器人专业系列10本、多轴与高速高精教材3本，智能制造教材2本、工业大数据教材1本，3D打印教材1本，先后在机械工业出版社、华中科技大学出版社、电子工业出版社出版，并配套有精品二维码微课资源，建设数字化教材。</div>
                                </div>
                                <!-- <div class="threeBox">
                                    专业化录课服务
                                </div> -->
                                <img src="../assets/serviceLeft.png" alt="">
                            </div>
                            <div class="right">
                                <img src="../assets/serviceRight.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box4">
                <div class="content">
                    <div class="commonTitle">
                        <div class="top">技能鉴定</div>
                        <div class="bottom">SKILL IDENTIFICATION</div>
                        <div class="astract">由机械工业职业技能鉴定指导中心授权，本单位作为机械行业能力评价考试站，支持工业机器人操作调整工和工业机器人装调维修工的技能鉴定。</div>
                        <img src="../assets/serviceModal2.png" alt="">
                    </div>
                </div>
            </div>
        
    </div>
</template>
<script>
import {getBannerListApi} from "@/request/api"
export default {
    name:"service",
    data(){
        return{
            bannerUrl:'',
            bannerLink:''
        }
    },
    mounted(){
        this.init()
    },
    methods:{
        init(){
            this.getToken(getBannerListApi,{},res=>{
                let info=res.data.filter(item=>item.link==4)[0]
                this.bannerUrl=info.banner_img
                this.bannerLink=info.banner_name
            })
        },
        changeLink(){
            if(this.bannerLink){
                window.open(this.bannerLink, '_blank')
            }
        }
    }
}
</script>
<style lang="stylus" scoped>
.service
    background:#f8f8f8;
    .content
        width:1200px;
        margin:30px auto 0;
        margin-top:0;
    .commonTitle
        width:100%;
        text-align center;
        margin-top:67px;
        .top
            font-size:34px;
            color:#333;
        .bottom
            font-size:16px;
            color:#999;
        .astract
            font-size:18px;
            color:#7c7c7c;
            text-align:center;
            line-height:30px;
            margin-top:30px;
            padding:40px;

        img 
            margin:50px 0;
    .box1
        height:418px;
        width:100%;
        background:#fff;
        ul
            display:flex;
            justify-content:space-between;
            li
                width:378px;
                height:274px;
                background:url('../assets/service3.png')
                background-repeat: no-repeat
                margin-top:75px;
                position:relative;
                &:nth-child(2)
                    background:url('../assets/service2.png') no-repeat;
                &:nth-child(3)
                    background:url('../assets/service1.png') no-repeat;
                .text
                    position:absolute;
                    top:50%;
                    left:50%;
                    width:100%;
                    text-align:center;
                    transform:translate(-50%,-50%)
                    .title
                        font-size:28px;
                        color:#333;
                        margin-bottom:40px;
                    .detail
                        font-size:18px;
                        color:#666;
    .box3
        height:1000px;
        .other
            display:flex;
            justify-content:space-between;
            margin-top:50px;
            .left
                padding-top:50px;
                width:45%;
                position relative
                img
                    position :absolute;
                    left:0;
                .smallBox
                    position:absolute;
                    border:1px solid #04ccfd;
                    padding:30px;
                    left:30px;
                    width:460px;
                    ul
                        padding-left:30px;
                        li
                            text-align:left;
                            display:flex;
                            align-items:center;
                            line-height:35px;
                            color:#7c7c7c;
                            span 
                                color:#fcbc3f
                                font-size:40px;
                    p
                        font-size:20px;
                        color:#333;
                        text-align:left;
                        padding-left:30px;
                        font-weight:bold;
                .bottomBox
                    top:350px;
                    padding-bottom:50px;
                    div 
                        color:#7c7c7c;
                        text-align:justify;
                        padding-left:30px;

            .right
                width:55%;
    .box4
        height:800px;
        .content
            margin-top:53px;
        img 
            margin:70px 0;
        
</style>
